export default __webpack_public_path__ + "static/media/accesibility.765e50a4.svg";